var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jInput date-time-container" },
    [
      _c("vue-clockpicker", {
        staticClass: "jFormGroup",
        class: _vm.inputClass,
        attrs: {
          value: _vm.stringTime,
          disabled: _vm.disabled,
          placeholder: _vm.placeholder,
          id: _vm.id
        },
        on: { timeset: _vm.getData }
      }),
      _vm._v(" "),
      _vm.errorRequired
        ? _c("label", { staticClass: "show" }, [
            _vm._v(_vm._s(_vm.errorMessage) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isFilled,
              expression: "isFilled"
            }
          ],
          staticClass: "x-container time"
        },
        [
          _c("img", {
            attrs: {
              src: require("@/assets/icon/xmark.svg"),
              alt: "Clear Value"
            },
            on: { click: _vm.clearValue }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-942e5050", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942e5050","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/jClockpicker.vue
// module id = null
// module chunks = 